import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { ModalService } from '../services/modal.service';

@Injectable()
export class ReqInterceptor implements HttpInterceptor {

  constructor(
    private readonly modalService: ModalService,
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    return next.handle(req).pipe(
      catchError((err: any) => {
        if (err.status === 400) {
          (err?.error?.errors || []).forEach((error: any) => {
            if (error?.code === 'MAX_INTEGRATION') {
              this.modalService.openTariffUpdate();
            }
          });
        }

        throw err;
      })
    );
  }
}
